export const SHOWTIMES_API_MODES = {
  NEAREST: 'nearest',
  IN: 'in',
  NETWORK: 'network',
  FAVORITES: 'favorites',
  REMAINING: 'remaining'
};

export const BOOKING = 'theater_has_booking';
export const LOYALTY_CARDS = 'loyalty_cards';
export const SHOWTIMES_COMFORT = 'showtimes.comfort';
export const SHOWTIMES_EXPERIENCE = 'showtimes.experience';
export const SHOWTIMES_PICTURE = 'showtimes.picture';
export const SHOWTIMES_PROJECTION = 'showtimes.projection';
export const SHOWTIMES_SOUND = 'showtimes.sound';
export const SHOWTIMES_VERSION = 'showtimes.version';

export const SHOWTIMES_EXPERIENCES_ICONS_CLASSES: Record<string, string> = {
  'Auditorium.Experience.4DEmotion': '4demotion',
  'Auditorium.Experience.4dx': '4dx',
  'Auditorium.Experience.DolbyAtmos': 'dolbyatmos',
  'Auditorium.Experience.DolbyCinema': 'dolbycinema',
  'Auditorium.Experience.DolbyVisionAtmos': 'dolbyvisionatmos',
  'Auditorium.Experience.GrandLarge': 'grandlarge',
  'Auditorium.Experience.Ice': 'ice',
  'Auditorium.Experience.Infinite': 'infinite',
  'Auditorium.Experience.LaserUltra': 'laserultra',
  'Auditorium.Experience.OnyxLed': 'onyxled',
  'Auditorium.Experience.ScreenX': 'screenx',
  'Format.Projection.3d': '3d',
  'Format.Projection.3d70mm': '3d',
  'Format.Projection.Imax': 'imax',
  'Format.Projection.Imax3d': 'imax3d',
  'Format.Projection.Imax70mm': 'imax',
  'Format.Projection.RealD3D': '3d',
  'Format.Sound.Atmos': 'dolbyatmos'
};

// Whitelist des vraies technos pour le filtre "Expériences" (ALLOCINE-15053) :
// exclut les non-technos (Numérique, 70mm, Analogique, 4K, Dolby 7.1, PLF, Luxury, etc.)
// Valeurs = translation.tag renvoyé par les facets GraphQL (nom d'enum, ex: E_4DX),
// à ne pas confondre avec les clés 'Auditorium.Experience.*' utilisées ci-dessus pour les icônes.
export const SHOWTIMES_EXPERIENCES_FILTER_TAGS = new Set([
  'F_3D',
  'F_3D70MM',
  'REALD_3D',
  'E_4D_EMOTION',
  'E_4DX',
  'DOLBY_ATMOS',
  'ATMOS',
  'DOLBY_CINEMA',
  'DOLBY_VISION_ATMOS',
  'ICE',
  'IMAX',
  'IMAX_3D',
  'IMAX_70MM',
  'INFINITE',
  'LASER_ULTRA',
  'ONYX_LED',
  'SCREEN_X',
  'THX',
  'GRAND_LARGE'
]);
